@if (redirectingToPayment) {
  <app-payment-loading-screen-atom></app-payment-loading-screen-atom>
} @else {
  <div
    class="min-h-screen pb-page-bottom"
    [style.backgroundColor]="backgroundColor | contentBuilderColor"
    [style.backgroundImage]="backgroundImageCss"
    [style.backgroundSize]="backgroundImageCss ? 'cover' : null"
    [style.backgroundPosition]="backgroundImageCss ? 'center' : null"
    [style.backgroundRepeat]="backgroundImageCss ? 'no-repeat' : null"
  >
    <app-block-list [blockIdList]="body"></app-block-list>
  </div>
}
